import React from 'react';
import { Button, Text } from '@chakra-ui/react';
import { parsearCoordenadas, generarUrlGoogleMapsDirections } from '../../utils/coordenadas';

/**
 * Botón reutilizable para ver rutas en Google Maps
 * 
 * @param {Object} props
 * @param {string} props.origen - Coordenadas de origen en formato "lat,lng"
 * @param {string} props.destino - Coordenadas de destino en formato "lat,lng"
 * @param {string} [props.size="sm"] - Tamaño del botón (xs, sm, md, lg)
 * @param {string} [props.variant="outline"] - Variante del botón
 * @param {string} [props.colorScheme="teal"] - Esquema de color
 * @param {boolean} [props.fullWidth=false] - Si el botón debe ocupar todo el ancho
 * @param {boolean} [props.showIcon=true] - Si debe mostrar el icono del mapa
 * @param {string} [props.label="Ruta"] - Texto del botón
 * @param {string} [props.className] - Clase CSS adicional
 * @param {Function} [props.onClick] - Callback adicional al hacer clic
 * @returns {JSX.Element}
 */
const BotonRuta = ({
  origen,
  destino,
  size = "sm",
  variant = "outline",
  colorScheme = "teal",
  fullWidth = false,
  showIcon = true,
  label = "Ruta",
  className = "",
  onClick
}) => {
  // Validar y parsear coordenadas
  const origenParsed = parsearCoordenadas(origen, 'origen');
  const destinoParsed = parsearCoordenadas(destino, 'destino');
  
  const tieneRuta = origenParsed.validas && destinoParsed.validas;
  const googleMapsUrl = tieneRuta 
    ? generarUrlGoogleMapsDirections(origenParsed.lat, origenParsed.lng, destinoParsed.lat, destinoParsed.lng)
    : '#';

  const handleClick = (e) => {
    if (!tieneRuta) {
      e.preventDefault();
      return;
    }
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      as={tieneRuta ? "a" : "button"}
      href={tieneRuta ? googleMapsUrl : undefined}
      target={tieneRuta ? "_blank" : undefined}
      rel={tieneRuta ? "noopener noreferrer" : undefined}
      size={size}
      width={fullWidth ? "full" : undefined}
      colorScheme={colorScheme}
      variant={variant}
      leftIcon={showIcon ? <Text fontSize="md">🗺️</Text> : undefined}
      isDisabled={!tieneRuta}
      onClick={handleClick}
      className={`boton-ruta ${className}`}
    >
      {label}
    </Button>
  );
};

export default BotonRuta;
